import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { gsap } from "gsap";
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Basics, isSmartphone } from '../_app/cuchillo/core/Basics';
import { Metrics } from '../_app/cuchillo/core/Metrics';

class ScrollItem__ProjectsItem extends Scroll_Item {
    _isItemShow = true;
    _headerDom;
    _offset = 0;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._headerDom = GetBy.selector(".header-page")[0];

        if (!isSmartphone) {
            this.onMove = (pos, size) => {

                if (pos.y > this._offset) {
                    this.hideItem();
                } else {
                    this.showItem();
                }
            };
        }
    }

    showItem() {
        if (this._isItemShow) return;
        this._isItemShow = true;
        this.item.style.opacity = 1;
    }

    hideItem() {
        if (!this._isItemShow) return;
        this._isItemShow = false;
        this.item.style.opacity = 0;
    }

    resize(w, h) {
        super.resize(w, h);
        if (!isSmartphone) {
            this._offset = -this._headerDom.offsetHeight * .9 + Number(this.item.dataset.offset) * Metrics.WIDTH * .024;
        }
    }

    loop() { }

    dispose() {
        super.dispose();
    }
}

Scroll._registerClass('ProjectsItem', ScrollItem__ProjectsItem);